/**
 * Given an array of tokens and values, the function will replace the tokens with the provided values
 * @param textToParse The text string to be parsed
 * @param tokens Key is the token, value is the string to replace with.
 * @returns The parsed string.
 */
export const parseStringTokens = (
	textToParse: string,
	tokens: { [key: string]: string },
) => {
	let parsedText = textToParse;
	for (const token in tokens) {
		parsedText = parsedText.replace(new RegExp(token, "g"), tokens[token]);
	}
	return parsedText;
};
